module.exports = __webpack_public_path__ + "static/images/containers/MainMenu/images/mainmenu-item-active-arrow-32.1a65a2aa.png";


//////////////////
// WEBPACK FOOTER
// ./containers/MainMenu/images/mainmenu-item-active-arrow-32.png
// module id = 3173
// module chunks = 11